import request from '@/utils/request'

export function createIssue(data) {
  // Une pièce jointe impose le multipart : on ne peut plus envoyer d'objet JSON,
  // et chaque champ se pose à plat. `page` reste un objet côté serveur, d'où la
  // notation en crochets que PHP recompose.
  const corps = new FormData()

  corps.append('title', data.title)
  corps.append('description', data.description ?? '')
  ;(data.labels ?? []).forEach(label => corps.append('labels[]', label))
  Object.entries(data.page ?? {}).forEach(([cle, valeur]) => {
    if (valeur !== null && valeur !== undefined) corps.append(`page[${cle}]`, valeur)
  })
  if (data.pieceJointe) corps.append('piece_jointe', data.pieceJointe)

  return request({
    url: '/api/gitlab/issues',
    method: 'post',
    data: corps,
    // La classification et la déduplication IA précèdent la création de l'issue :
    // le timeout par défaut de 10 s laisse trop peu de marge.
    override_timeout: 30000,
  })
}
